import axios from "axios";
import { useState, useEffect } from "react";
import "./App.css";

const languages = [
  { value: "English", label: "en" },
  { value: "French", label: "fr" },
  { value: "Spanish", label: "es" },
  { value: "German", label: "de" },
  { value: "Italian", label: "it" },
  { value: "Russian", label: "ru" },
];

function App() {
  const [language_code, setLanguageCode] = useState("en");
  const [word, setWord] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);

  const dictionaryApi = async (language_code, word) => {
    try {
      const { data } = await axios.get(
        `https://api.dictionaryapi.dev/api/v2/entries/${language_code}/${word}`
      );
      setError(false);
      setData(data);
    } catch (error) {
      setError(true);
      console.log(error);
    }
  };

  useEffect(() => {
    // Debounce the API call slightly to improve performance on typing
    const timer = setTimeout(() => {
      if (word !== "" && language_code === "en") {
        dictionaryApi(language_code, word);
      } else {
        setData([]);
        setError(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [word, language_code]);

  return (
    <div className="app">
      <div className="glass-container">
        <header className="header">
          <h1 className="title">Dictionary</h1>
          <p className="subtitle">Find meanings, phonetics, and more.</p>
        </header>

        <div className="inputs-container">
          <div className="search-box">
            <input
              type="text"
              className="search-input"
              placeholder="Type a word..."
              value={word}
              onChange={(e) => setWord(e.target.value)}
            />
          </div>

          <div className="language-select">
            <select
              className="custom-select"
              value={language_code}
              onChange={(e) => setLanguageCode(e.target.value)}
            >
              {languages.map((lang) => (
                <option key={lang.label} value={lang.label}>
                  {lang.value}
                </option>
              ))}
            </select>
          </div>
        </div>

        <main className="results-container">
          {language_code !== "en" ? (
            <div className="coming-soon-message">
              <h2>{languages.find(l => l.label === language_code)?.value} Coming Soon</h2>
              <p>We are working on adding support for this language.</p>
            </div>
          ) : (
            <>
              {word === "" && (
                <div className="welcome-message">
                  Welcome! Start typing to search purely based on English.
                </div>
              )}

              {error && <div className="error-message">No definition found.</div>}

              {data.length > 0 && (
                <div className="word-result">
                  <div className="word-header">
                    <h2>{data[0].word}</h2>
                    {data[0].phonetics && data[0].phonetics.length > 0 && (
                      <span className="phonetic">{data[0].phonetics[0].text}</span>
                    )}
                  </div>

                  <div className="audio-player">
                    {data[0].phonetics && data[0].phonetics.find(p => p.audio) && (
                      <audio controls src={data[0].phonetics.find(p => p.audio).audio}>
                        Your browser does not support the audio element.
                      </audio>
                    )}
                  </div>

                  <div className="meanings">
                    {data[0].meanings?.map((meaning, index) => (
                      <div key={index} className="meaning-group">
                        <h3 className="part-of-speech">{meaning.partOfSpeech}</h3>
                        {meaning.definitions.map((def, idx) => (
                          <div key={idx} className="definition-item">
                            <p className="definition-text">{def.definition}</p>
                            {def.example && (
                              <p className="example-text">
                                "{def.example}"
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
}

export default App;
